module.exports = __webpack_public_path__ + "static/media/ic_it.caaa4362.svg";